import { Box, Card, IconButton, TextField, Typography } from "@mui/material"
import React, { useEffect, useMemo, useState } from "react"
import { fCurrency } from "../../utils/formatNumbers"

import DoneIcon from "@mui/icons-material/Done"
import { toast } from "react-toastify"
import api from "../../services/api"

import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import ModalConfirm from "../ModalConfirm"

function TicketProductListItem({ product, ticketId, onDelete }) {
    const [editProduct, setEditProduct] = useState(false)
    const [quantity, setQuantity] = useState(1)

    const [modalDelete, setModalDelete] = useState(false)

    const valorTotal = useMemo(() => {
        return quantity * product.price
    }, [product.price, quantity])

    useEffect(() => {
        setQuantity(product.TicketProduct.quantidade)
    }, [product.TicketProduct.quantidade])

    const handleEditFinish = async () => {
        try {
            setEditProduct(false)
            await api.put(`/ticketProducts/${ticketId}/${product.id}`, {
                quantity: Number(quantity),
                discount: 0,
            })
            toast.success("Produto editado com sucesso")
        } catch (error) {
            toast.error("Erro ao editar produto")
        }
    }

    return (
        <>
            <ModalConfirm
                open={modalDelete}
                onCancel={() => setModalDelete(false)}
                title="Remover produto?"
                description="Você pode adicionar este produto novamente se quiser"
                onApprove={() => onDelete(product.id)}
            />
            <Card
                variant="outlined"
                sx={{
                    p: 2,
                    position: "relative",
                    mb: 1,
                }}
            >
                <Box display="flex" position="absolute" right={0} top={0}>
                    <IconButton onClick={() => setEditProduct(true)}>
                        <EditIcon />
                    </IconButton>
                    <IconButton onClick={() => setModalDelete(true)}>
                        <DeleteIcon color="secondary" />
                    </IconButton>
                </Box>
                <Typography variant="caption">Produto</Typography>
                <Typography variant="h6">{product.name}</Typography>

                <Box display="flex" justifyContent="space-between">
                    <Box display="flex" flexDirection="column">
                        <Typography variant="caption">Quantidade</Typography>
                        {editProduct ? (
                            <Box display="flex">
                                <TextField
                                    type="number"
                                    size="small"
                                    onKeyDown={({ key }) => {
                                        if (key === "Escape") {
                                            setEditProduct(false)
                                        }
                                        if (key === "Enter") {
                                            handleEditFinish()
                                        }
                                    }}
                                    value={quantity}
                                    onChange={(e) =>
                                        setQuantity(e.target.value)
                                    }
                                />
                                <IconButton onClick={handleEditFinish}>
                                    <DoneIcon />
                                </IconButton>
                            </Box>
                        ) : (
                            <Typography
                                role="button"
                                onClick={() => setEditProduct(true)}
                                sx={{ cursor: "pointer" }}
                            >
                                {quantity}
                            </Typography>
                        )}
                    </Box>
                    <Box display="flex" flexDirection="column">
                        <Typography variant="caption">Valor total</Typography>
                        <Typography>{fCurrency(valorTotal)}</Typography>
                    </Box>
                </Box>
            </Card>
        </>
    )
}

export default TicketProductListItem
